__turbopack_context__.v({
  "className": "geistmono_7474a881-module__jnBNeW__className",
  "variable": "geistmono_7474a881-module__jnBNeW__variable",
});
